// Mock data for Supercafard agency website

export const AGENCY = {
  name: "Supercafard",
  tagline: "agence de communication",
  years: 10,
  team: 20,
  offices: ["Paris", "Barcelone", "Bucarest", "Velles", "Ingrannes", "Bordeaux", "Bugueles", "Los Angeles"],
  manifesto:
    "Si les licornes sont sans cesse mises en lumière, les cafards savent rester dans l'ombre.",
  contact: {
    phone: "06 70 81 23 07",
    email: "florent@supercafard.com",
  },
};

export const SERVICES = [
  {
    id: "strategie",
    number: "01",
    title: "Stratégie",
    subtitle: "« Archéologie de marque »",
    points: [
      "Définition des dimensions d'une marque",
      "Plateforme de marque et raison d'être",
      "Architecture de marque",
    ],
  },
  {
    id: "creation",
    number: "02",
    title: "Création verbale & visuelle",
    subtitle: "Identité et expression",
    points: [
      "Identité de marque",
      "Packaging design",
      "Brand Cues",
      "Communication",
    ],
  },
  {
    id: "innovation",
    number: "03",
    title: "Innovation",
    subtitle: "« Voyage dans le futur »",
    points: [
      "Idéation nouveaux produits",
      "Prospective marque",
      "Nouveaux territoires",
    ],
  },
  {
    id: "production",
    number: "04",
    title: "Production",
    subtitle: "Faire, avec exigence",
    points: ["Audio-vidéo", "Photo", "3D"],
  },
];

export const CLIENTS = [
  "Abylon",
  "Birdz",
  "Ensio",
  "Air Liquide",
  "Daunat",
  "Goûters Magiques",
  "Tahiti",
  "Whaou!",
  "Le Ster",
  "Sud & Sol",
  "Havana Club",
  "Lay's",
  "Loxam",
  "Boulangers Bretons",
  "VRI",
  "PepsiCo",
  "Carglass",
  "Reservoir Swiss",
  "BNP Paribas",
  "Gisèle Delorme",
  "UPMC Sorbonne",
  "Veolia",
  "Adopt Parfums",
  "Armor Délices",
  "Salon de la Photo",
  "Parfum d'Empire",
  "Dessaint",
  "LADAPT",
  "Fondation Foch",
  "Vous ?",
];

export const CASES = [
  {
    id: "daunat",
    client: "Daunat",
    period: "2019 — 2026",
    title: "Le plein de vie",
    category: "Plateforme de marque · Film TV · Packaging",
    color: "#E4002B",
    image:
      "/media/daunat.webp",
    video: "M_vV4tlHFYw",
    challenge:
      "En 2020, Daunat n'a pas communiqué en TV depuis 4 ans. Résultats décevants, PDM faibles face à la concurrence. Comment repenser entièrement une marque en conservant son positionnement ?",
    solution:
      "Refonte complète de la plateforme de marque, brand design, packaging, caractérisée par une nouvelle signature : Le plein de vie. Un premier film en 2021, et chaque année depuis.",
    results: [
      { value: "+81", label: "places dans les marques préférées des Français" },
      { value: "+1,9 pts", label: "de PDM en GMS" },
      { value: "+21%", label: "RHD" },
      { value: "+26%", label: "de CA tous réseaux" },
    ],
  },
  {
    id: "whaou",
    client: "Whaou!",
    period: "2024 — 2026",
    title: "Libère ton Whaou!",
    category: "Plateforme de marque · Logo · Packaging · Film TV",
    color: "#FFCB05",
    image:
 "/media/whaou.webp",
    video: "xjdACmIpmJw",
    challenge:
      "Remise à plat 360° de la marque. Plateforme, logo, cues, packs, film TV, com interne, activation commerciale.",
    solution:
      "Stratégie : remettre du whaou dans le Whaou! Redesign du logo, de la mascotte et des 4 gammes. Lancement Reverse Room et activations Chandeleur.",
    results: [
      { value: "4", label: "gammes refondues" },
      { value: "360°", label: "de refonte de marque" },
      { value: "1", label: "nouvelle mascotte iconique" },
    ],
  },
  {
    id: "ensio",
    client: "Ensio",
    period: "2022",
    title: "La nouvelle marque des réseaux",
    category: "Archéologie de marque · Naming · Identité · Signalétique",
    color: "#1E3A8A",
    image:
      "/media/ensio.png",
    challenge:
      "Création d'une nouvelle identité de marque regroupant trois entités : Cottel Réseaux (2006), ETE Réseaux (2000) et SADE Télécom, tout en respectant le capital humain et le métier de chaque entité historique.",
    solution:
      "Après analyse de l'environnement et benchmark concurrentiel, construction d'une archéologie de marque, recommandations, positionnement et raison d'être. Naming, création du logo, du territoire visuel et déclinaisons graphiques. Communication interne (onboarding des collaborateurs) et externe (site internet, vidéo corporate, signalétique).",
    results: [
      { value: "3", label: "entités unifiées sous une marque" },
      { value: "1", label: "nouveau naming et logo" },
      { value: "360°", label: "déploiement interne & externe" },
    ],
  },
  {
    id: "tahiti",
    client: "Tahiti",
    period: "2024 — 2025",
    title: "#TahitiBreakFree",
    category: "Plateforme · Packaging · Événementiel Garorock",
    color: "#00A19A",
    image:
 "/media/tahiti.webp",
    challenge:
      "Une évolution plutôt qu'une révolution. Réécriture de plateforme, aménagement du design pack, accompagnement activations commerciales, présence festival.",
    solution:
      "Nouvelle signature et déploiement du mix. Refonte packs Tahiti (Coco Wave, Mango Splash, Yuzu Peps). Conception de la cabine Garorock 2025 et mini-enceinte collector.",
    results: [
      { value: "3", label: "nouvelles variétés packaging" },
      { value: "1000", label: "enceintes collector distribuées" },
    ],
  },
];

export const AWARDS = [
  { rank: 1, brand: "Novotel", score2025: "74.5%", score2024: "63.7%", increase: "+10.8" },
  { rank: 2, brand: "Kiri", score2025: "66.5%", score2024: "57.3%", increase: "+9.2" },
  { rank: 3, brand: "Twix", score2025: "65.8%", score2024: "57.1%", increase: "+8.7" },
  { rank: 4, brand: "Daunat", score2025: "56.2%", score2024: "47.5%", increase: "+8.7", highlight: true },
  { rank: 5, brand: "Poulain", score2025: "76.7%", score2024: "68.5%", increase: "+8.2" },
  { rank: 10, brand: "Whaou!", score2025: "54.3%", score2024: "47.5%", increase: "+6.8", highlight: true },
];


